module.exports = __webpack_public_path__ + "img/transfer-list.e979570f.svg";